import { render } from "./FollowsEdit.vue?vue&type=template&id=125520bc"
import script from "./FollowsEdit.vue?vue&type=script&lang=js"
export * from "./FollowsEdit.vue?vue&type=script&lang=js"

import "./FollowsEdit.vue?vue&type=style&index=0&id=125520bc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__